/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {defineStyleConfig} from '@chakra-ui/styled-system';

export default defineStyleConfig({
  baseStyle: {
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
  },
});
